import {GetRequestResponsePayload} from '../../../models/api';

export default {
  id: 111,
  number: 1123,
  topic: 'Вопрос по карте ЕСК',
  text: 'Какой то тестовый вопрос',
  dateTime: '2020-06-09T13:24Z',
  response: 'Какой то тестовый ответ',
  appealFiles: [
    {
      id: '1',
      name: 'request.png',
    },
  ],
  responseFiles: [
    {
      id: '2',
      name: 'response.png',
    },
  ],
} as GetRequestResponsePayload;
